module.exports = __webpack_public_path__ + "975feea8d0818a88600e635bf4a9fe68.png";